export const IncentiveTypes = {
    RESIDENTIAL: 'Residential',
    COMMERCIAL: 'Commercial',
};

export const isValidIncentiveType = (type: string): boolean => {
    return Object.values(IncentiveTypes).includes(type);
};
